import { Component, OnInit } from '@angular/core';
import { forkJoin, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { GetEmpty } from 'src/app/classes/Empties';
import { ItemInfo } from 'src/app/models/models';
import { Item_Points } from 'src/app/models/RestModels';
import { BaseComponent } from '../base/base.component';

@Component({
	selector: 'app-save-item-points',
	templateUrl: './save-item-points.component.html',
	styleUrls: ['./save-item-points.component.css'],
})
export class SaveItemPointsComponent extends BaseComponent implements OnInit
{
    item_points: Item_Points = GetEmpty.item_points();
    item_info: ItemInfo | null;

	ngOnInit(): void
	{
		this.sink = this.route.paramMap.pipe
		(
			mergeMap((param_map) =>
			{
				return param_map.get('id')
					?  this.rest.item_points.get(param_map.get('id'))
					: of( GetEmpty.item_points() );
			}),
			mergeMap((item_points) =>
			{
				let item_info_obs = item_points.item_id
					? this.rest.item_info.get( item_points.item_id )
					: of(GetEmpty.item_info());

				return forkJoin
				({
					item_points: of( item_points ),
					item_info:item_info_obs
				});
			})
		)
		.subscribe
		({
			next:(response)=>
			{
				this.item_points = response.item_points;
				this.item_info = response.item_info;
				this.is_loading = false;
			},
			error:(error)=>
			{
				this.showError(error);
			}
		});
	}
	save(evt:Event)
	{
		evt.preventDefault();
		evt.stopPropagation();

		if( !this.item_info?.item?.id )
		{
			return this.showError('Por favor seleccione un articulo');
		}

		this.item_points.item_id = this.item_info.item.id;

		this.sink = this.rest.item_points
		.create( this.item_points )
		.subscribe
		({
			next:(response)=>
			{
				this.showSuccess('Puntos guardados');
				this.router.navigate(['/item-points']);
			},
			error:(error)=>
			{
				this.showError(error);
			}
		});
	}
	onItemInfoSelected(item_info:ItemInfo)
	{
		this.item_info = item_info;
	}
}
